'use strict';

var homePageVideo = document.getElementById('intro-video');

var initHomePageVideoInteractions = function initHomePageVideoInteractions() {
  handleSoundControlClicked();
  onVideoLoaded();
};

var initPageAfterLoading = function initPageAfterLoading() {
  document.querySelector('body').classList.add('initialized');
};

var onVideoLoaded = function onVideoLoaded() {
  homePageVideo.preload = "auto";
  var isPlayTypeAllowedByBrowser = homePageVideo.canPlayType('video/mp4; codecs="avc1.42E01E, mp4a.40.2"');
  homePageVideo.addEventListener('canplay', initPageAfterLoading);
  // Instantly remove loading screen for browsers who can't play current video
  if (!isPlayTypeAllowedByBrowser || isPlayTypeAllowedByBrowser === "maybe") {
    initPageAfterLoading();
  } else {
    setTimeout(initPageAfterLoading, 2000);
  }
};

var handleSoundControlClicked = function handleSoundControlClicked() {
  var controlSection = document.querySelector('.controls');
  if (!controlSection) {
    return;
  }
  controlSection.addEventListener('click', function () {
    controlSection.querySelectorAll('span').forEach(function (icon) {
      icon.classList.toggle('hidden');
    });
    homePageVideo.muted = !homePageVideo.muted;
  });
};

homePageVideo && initHomePageVideoInteractions();


//////////////////
// WEBPACK FOOTER
// ./js/homepage/video.js
// module id = ./js/homepage/video.js
// module chunks = 0